module.exports = __webpack_public_path__ + "img/application-title.011a0770.png";